<div class="overlay overlay--{{ data.backgroundColor }}" [ngClass]="data.zIndex ? 'overlay--bottom' : 'overlay--top'"></div>
